import React, { useEffect, useState } from "react";
import { Content, Main } from "../../../components/Layout";
import api from "../../../services/api";

import { Table, Row, Col } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import Pagenation from "../../../components/Pagenation";
import tableStyle from "../../../components/Table/Table.module.css";
import { formatDate } from "../../../util/functions";
import IcEditar from "../../../components/Svg/IcEditar";
import styleButton from "../../../components/Button/Button.module.css";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";

export default function Users() {
  const { setbreadcrumb, config } = useWrapper();

  const navigate = useNavigate();

  const [page, setPage] = useState({
    total: null,
    current: 1,
  });
  const pageChange = p => {
    setPage({
      ...page,
      current: p,
    });
  };

  const [loadingPage, setLoadingPage] = useState(true);
  const [reload, setreload] = useState();
  const [users, setusers] = useState([]);

  useEffect(() => {
    api
      .get(`users?page=${page.current}`, config)
      .then(response => {
        if (page.total !== response.data.lastPage) {
          setPage({
            ...page,
            total: response.data.lastPage || 1,
          });
        }
        if (page.current) {
          setusers(response.data.data);
        }
      })
      .then(() => {
        setLoadingPage(false);
      });
  }, [reload]);

  useEffect(() => {
    if (page.current) {
      setreload(!reload);
    }
  }, [page.current]);

  useEffect(() => {
    setbreadcrumb([{ label: "Gerenciar Usuários" }]);
  }, []);

  return (
    <Main>
      {!loadingPage ? (
        <Content>
          <Row>
            <Col>
              <h2 className="mini-title">Gerenciar Usuários</h2>
              <p className="small-label font-italic mb-3">Crie e Edite Usuários.</p>
            </Col>
            <Col className="d-flex justify-content-end align-items-start">
              <NavLink className={styleButton.button_primary} to="/admin/users/new">
                Novo Usuário
              </NavLink>
            </Col>
          </Row>
          <Table className={tableStyle.table}>
            <thead>
              <tr>
                <th>Usuário</th>
                <th>Setor</th>
                <th>E-Mail</th>
                <th>Último Acesso</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.map(e => (
                <tr onClick={() => navigate(`/admin/users/${e.id}`)}>
                  <td>
                    <b>{e.username}</b>
                  </td>
                  <td>{e.sector}</td>
                  <td>{e.email}</td>
                  <td>{e.last_acess ? formatDate(e.last_acess) : "-"}</td>
                  <td>
                    <button className="simple-ico float-right">
                      <IcEditar />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagenation current={page.current} total={page.total} pageChange={pageChange} className="mt-3" />
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
